import { gql } from "@apollo/client"

export const DeleteCoupon = gql`
mutation DeleteCoupon($deleteCouponId: ID!) {
  deleteCoupon(id: $deleteCouponId) {
    status
  }
}
`